const About = () => {
  return (
    <section id="about" className="mb-12">
      <h2 className="text-3xl font-bold mb-4">About Me</h2>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-700 mb-4">
          Software Developer with experience in HTML, CSS, JavaScript, Node.js,
          and Express.js. AWS Certified Cloud Practitioner passionate about
          building web applications.
        </p>
      </div>
    </section>
  );
};

export default About;
